module.exports = __webpack_public_path__ + "static/taapi-hero-3c384fcfdf160ba9f85f4c4a316a3aea.jpg";